/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Claims support at most 10 auto-import rules and 2048 combined UTF-8 bytes of rule values.
 * @export
 * @interface CreateEmailMatchRuleRequest
 */
export interface CreateEmailMatchRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateEmailMatchRuleRequest
     */
    ruleType: CreateEmailMatchRuleRequestRuleTypeEnum;
    /**
     * Email address (for ruleType email) or normalized subject term (for ruleType subject)
     * @type {string}
     * @memberof CreateEmailMatchRuleRequest
     */
    value: string;
}


/**
 * @export
 */
export const CreateEmailMatchRuleRequestRuleTypeEnum = {
    Email: 'email',
    Subject: 'subject'
} as const;
export type CreateEmailMatchRuleRequestRuleTypeEnum = typeof CreateEmailMatchRuleRequestRuleTypeEnum[keyof typeof CreateEmailMatchRuleRequestRuleTypeEnum];


/**
 * Check if a given object implements the CreateEmailMatchRuleRequest interface.
 */
export function instanceOfCreateEmailMatchRuleRequest(value: object): value is CreateEmailMatchRuleRequest {
    if (!('ruleType' in value) || value['ruleType'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function CreateEmailMatchRuleRequestFromJSON(json: any): CreateEmailMatchRuleRequest {
    return CreateEmailMatchRuleRequestFromJSONTyped(json, false);
}

export function CreateEmailMatchRuleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmailMatchRuleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ruleType': json['ruleType'],
        'value': json['value'],
    };
}

export function CreateEmailMatchRuleRequestToJSON(json: any): CreateEmailMatchRuleRequest {
    return CreateEmailMatchRuleRequestToJSONTyped(json, false);
}

export function CreateEmailMatchRuleRequestToJSONTyped(value?: CreateEmailMatchRuleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ruleType': value['ruleType'],
        'value': value['value'],
    };
}

